enum CampaignStatus {
  COMPLETED = 'C',
  RUNNING = 'R',
  UPCOMING = 'U',
}

export default CampaignStatus;
